import {User} from '../model/user.model';
import {Injectable} from '@angular/core';
import {UserInteractor} from './user.interactor';
import {LoginHelper} from '../helpers/login.helper';
import {LoginService} from '../service/login.service';

@Injectable()
export class LoginInteractor {
    private readonly loginHelper: LoginHelper;
    private readonly loginService: LoginService;
    private readonly userInteractor: UserInteractor;

    constructor(loginService: LoginService, loginHelper: LoginHelper, userInteractor: UserInteractor) {
        this.loginService = loginService;
        this.loginHelper = loginHelper;
        this.userInteractor = userInteractor;
    }

    public async requestLogIn(loginId: string, isVerifyRequest?: boolean): Promise<{ id: string; maskedPhoneNumber: string }> {
        const isPhoneNumber = /^\d{10}$/.test(loginId);
        const isPan = /^[a-zA-Z]{5}\d{4}[a-zA-Z]$/.test(loginId);
        if (isPhoneNumber) {
            return this.loginService.createLoginRequestWithPhoneNumber(loginId, isVerifyRequest);
        } else if (isPan) {
            return this.loginService.createLoginRequestWithPan(loginId);
        } else {
            return this.loginService.createLoginRequestWithUserId(loginId);
        }
    }

    public async verifyPassword(loginRequestId: string, password: string): Promise<User> {
        const {userId, token} = await this.loginService.verify(loginRequestId, password);
        await this.loginHelper.saveUserToken(userId, token);

        const user = await this.userInteractor.get();
        await this.loginHelper.saveUserDetails(user, token);

        return user;
    }

    public async requestVerification(phoneNumber: string, userId: string) {
        return this.loginService.createVerificationRequest(phoneNumber, userId);
    }
}
